import styled from "styled-components";
import { COLORS, responsive, THEME } from "../../styles/constants.style";
import {
  body1Regular,
  fontWeightBold,
  h3Regular,
} from "../typography/MuiTypography.style";

export const MuiSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 5px;
  ${responsive.MOBILE`
        margin-top: 0px;
    `}
  .title {
    display: flex;
    align-items: baseline;
  }

  .tooltip-container {
    position: relative;
  }

  .tooltip-wrapper {
    position: absolute;
    bottom: 5px;
  }

  &.horizontal-wrapper {
    flex-direction: row;
    .title {
      align-items: center;
    }

    .mui-select {
      width: 190px;
    }
  }

  .mui-label {
    color: ${COLORS.cirrus_black10};
    line-height: 20px;
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black7};
    }
  }

  .horizontal-label {
    font-family: Inter;
    font-weight: 500;
    font-size: 18px;
    color: ${COLORS.cirrus_black_dark};
    display: flex;
    align-items: center;
    margin-bottom: 0;
    margin-right: 12px;
  }

  .info-container {
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    gap: 8px;
    align-items: center;
    color: ${COLORS.cirrus_black};

    svg {
      vertical-align: unset !important;
    }
  }

  .asterisk {
    color: ${COLORS.cirrus_red};
  }
  .mui-select {
    border-color: ${COLORS.cirrus_black4};
    border-radius: 8px;
    background-color: ${COLORS.cirrus_black1};
    color: ${COLORS.cirrus_black};
    & fieldset {
      border-color: ${COLORS.cirrus_black4};
    }
    &:hover fieldset {
      border-color: ${COLORS.cirrus_black};
    }

    &:focus-within fieldset,
    &.Mui-focused fieldset,
    &.MuiSelect-outlined.MuiSelect-outlined.Mui-focused fieldset {
      border-color: ${COLORS.cirrus_black};
      border-width: 1px;
    }

    &.Mui-error {
      fieldset {
        border: 2px solid ${COLORS.cirrus_red};
      }
    }
    .MuiSelect-iconOutlined {
      width: 32px;
      height: 27px;
      color: ${COLORS.primary_light_blue};
      margin-right: 4px;
    }

    .MuiSvgIcon-root.Mui-disabled {
      color: ${COLORS.cirrus_black5};
    }
  }

  .mui-select.Mui-disabled {
    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.cirrus_black2} !important;
      pointer-events: none;
    }
  }

  .MuiFormHelperText-root {
    margin-top: 8px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    color: ${COLORS.cirrus_red};
  }

  .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
    box-sizing: border-box;
    padding: 15px 16px;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    width: calc(100% - 20px);

    ${responsive.MOBILE`
      font-size: 16px;
    `}
  }

  .Mui-disabled {
    color: ${COLORS.cirrus_black7} !important;
  }

  /* MuiMultiSelect styles */
  .selected-country-display {
    display: flex;
    align-items: center;

    .country-icon {
      height: 24px;
      width: 24px;
      margin-right: 8px;
    }

    .label-name {
      ${h3Regular}
      ${fontWeightBold}
      color: ${COLORS.cirrus_black};
    }
    .label-code {
      ${body1Regular}
      line-height: 19.36px;
      margin-left: 8px;
      color: ${COLORS.cirrus_black};
    }
  }
  .error-icon {
    display: flex;
    flex-direction: row;
    word-break: break-word;
  }
`;

export const searchWithInputStyle = {
  maxHeight: "250px",
  overflowY: "auto",

  "& .MuiMenuItem-root": {
    wordBreak: "break-word",
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
  "& .MuiList-root": {
    paddingTop: "0px",
  },
  "& .bold-option-title": {
    fontWeight: THEME.fontWeights["bold"],
  },
};

export const SelectTextboxWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${COLORS.cirrus_white};
  padding-top: 8px;
  .select-search-input {
    margin: 0px 5px 8px;
    .MuiOutlinedInput-root {
      border-radius: 8px;
    }
    .MuiInputAdornment-root {
      margin: 0;
      color: ${COLORS.primary_light_blue};
    }
  }
`;
